import { render } from "./PritaM.vue?vue&type=template&id=5db70450&scoped=true"
import script from "./PritaM.vue?vue&type=script&lang=js"
export * from "./PritaM.vue?vue&type=script&lang=js"

import "./PritaM.vue?vue&type=style&index=0&id=5db70450&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db70450"]])

export default __exports__